import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    btnExport,
    restartState
  } from '../../store/channelmap/basedatos/actions';

import { Body, Footer, Page } from '@sigeco/tools';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';

import BaseDatosFilter from '../../components/channelmap/basedatos/BaseDatosFilter';

const BaseDatos = ({onClose, setTitle}) => {
    const loading = useSelector(state => state.basedatos.loading);
    const usuario = useSelector(state => state.session.user.usuario);
    const dispatch = useDispatch();
//prueba para que suba
    useEffect(() => {
        setTitle('Descargar');
    // eslint-disable-next-line
    }, []);

    function onBtnClose() {
        dispatch(restartState());
        onClose();
    }

    const permisoExportar = (usuario === 'lpamiranda' || usuario === 'lpcmancipe') ? false : true;

    return (
        <Page>
            <Backdrop style={{ position: 'absolute', zIndex: 1200 }} open={loading} transitionDuration={0}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <Body>
            <BaseDatosFilter />
        </Body>
        <Footer>
            {permisoExportar &&
                <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => dispatch(btnExport())}
                    startIcon={<Icon className="fas fa-file-excel"/>}
                >
                    Exportar
                </Button>
            }
            <Button 
                color="primary" 
                size="small" 
                variant="outlined" 
                onClick={() => onBtnClose()} 
                startIcon={<Icon className="fas fa-door-open"/>}
            >
                Salir
            </Button>
        </Footer>
        </Page>
    )
};

export default BaseDatos;